export const uxReducerPath = 'ux';
